// extracted by mini-css-extract-plugin
export default {"tableWrap":"Invoices_tableWrap__dBU5i","table":"Invoices_table__KaqIl","actionBtn":"Invoices_actionBtn__CdKlm"};